import { render, staticRenderFns } from "./EventAuthTable.vue?vue&type=template&id=68de0547&scoped=true&lang=pug"
import script from "./EventAuthTable.vue?vue&type=script&lang=js"
export * from "./EventAuthTable.vue?vue&type=script&lang=js"
import style0 from "./EventAuthTable.vue?vue&type=style&index=0&id=68de0547&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68de0547",
  null
  
)

export default component.exports